import React, { useEffect, useState } from "react";
import axios from "axios";

const CharacterImage = ({ filename, name, storyId, src }) => {
  const [imageSrc, setImageSrc] = useState(null);


   // get assets
   const source = src; // public\upload or public_uploads
  
  useEffect(() => {
    const fetchImage = async () => {
      try {
        const url =
          source === "pubup"
            ? `/api/characters/imagefile/${filename}`
            : `/api/assets/${storyId}/imagefile/${filename}`;
    
        const res = await axios.get(url, {
          responseType: "blob",
          withCredentials: true,
        });
    
        const blobUrl = URL.createObjectURL(res.data);
        setImageSrc(blobUrl);
      } catch (error) {
        console.error("Error fetching image blob:", error);
      }
    };

    console.log("filename::>>>>>>>>>>>>>>>>>>", source, filename);
    console.log("imageSrc::>>>>>>>>>>>>>>>>>>", imageSrc);


    if (filename) {
      fetchImage();
    }
  }, [filename, storyId, src]);

  return (
    <img
      src={imageSrc}
      alt={name}
      className="character-image"
    />
  );
};

export default CharacterImage;